import {Spinner} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import PrivateIpsSection from './PrivateIpsSection';
import DhcpServerSection from './DhcpServerSection';
import DhcpLeasesSection from './DhcpLeasesSection';
import DhcpOptionsSection from './DhcpOptionsSection';
import {useGetLan} from '../../Hooks/RouterManager';
import LoadingOverlay from '../../../../app/common/components/LoadingOverlay';

interface LanPageProps {
  routerId: string;
}

const maskToBits = (mask: string): number =>
  mask
    .split('.')
    .reduce((bits, octet) => bits + (parseInt(octet, 10).toString(2).match(/1/g)?.length ?? 0), 0);

const LanPage = ({routerId}: LanPageProps): JSX.Element => {
  const intl = useIntl();
  const {data: lan, isLoading, isFetching} = useGetLan(routerId);

  if (isLoading || !lan) {
    return (
      <div className="text-center py-10">
        <Spinner animation="border" />
      </div>
    );
  }

  const networks = lan.privateIps.map((ip) => `${ip.address}/${maskToBits(ip.mask)}`);

  return (
    <LoadingOverlay isLoading={isFetching}>
      <p className="text-muted mb-4">
        {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.SUBTITLE'})}
      </p>
      <PrivateIpsSection routerId={routerId} ips={lan.privateIps} />
      <DhcpServerSection routerId={routerId} server={lan.dhcpServer} networks={networks} />
      <DhcpLeasesSection routerId={routerId} leases={lan.leases} />
      <DhcpOptionsSection routerId={routerId} options={lan.options} />
    </LoadingOverlay>
  );
};

export default LanPage;
